import {ANNOTATION_VIDEO_DISPLAY, ANNOTATION_PARENT, VIDEO_PLAYING_MODE} from './GlobalConstants';
import * as THREE from 'three';

export const ANNOTATION_CONTACT_TEXT = '';
export const CONTACT_URL = 'WEBSITE';
export const YOUTUBE = 'YOUTUBE';
export const INSTAGRAM = 'INSTAGRAM';
export const SPOTIFY = 'SPOTIFY';
export const TWITTER = 'TWITTER';
export const TIKTOK = 'TIKTOK';
export const IMDB = 'IMDB';
export const FACEBOOK = 'FACEBOOK';
export const ENQUIRE_EMAIL = 'ENQUIRE';
export const LINKED_IN = 'LINKEDIN';
export const HAS_MEDIA_CAROUSEL_LINK = 'MORE';
export const SEND_TO_EMAIL = 'SEND TO';
export const CANTALOUPE_IMAGE_SERVER = "http://18.130.251.124:8080/iiif/2/test01%2Fmichael-hill%2Fshow-01%2F";
export const ANNOTATION_TEXT_ALIGNMENT = "left" || "center";
export const ANNOTATION_TEXT_LINE_HEIGHT = "2.5" || "1.5";
export const GALLERY_LINK_LABEL = "WORKS";

const AnnotationsDB = [
    /* Videos begin */
    {
        paintingId: 'W01V01',
        videoId: 'W01V01',
        standaloneVideoElementId: 'W01V01',
        videoURL: 'W01V01.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: ``,
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: 'N',
        // videoPlaySpriteImageURL: '/assets/sprites/videoPlayButtonBlack.svg',
        // videoPauseSpriteImageURL: '/assets/sprites/videoPauseButtonBlack.svg',
        // videoButtonScale: {x: .2, y: .2, z: .2},
        // videoButtonPos:{x:9.17728, y:0.606917,z:11.6652},
        videoTextureEncoding: THREE.sRGBEncoding,
       // videoButtonPos:{x:-8.31443,y:-1.5 ,z:-29.7395 }
    },
    {
        paintingId: 'W02V01',
        videoId: 'W02V01',
        standaloneVideoElementId: 'W02V01',
        videoURL: 'W02V01.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: ``,
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: 'N',
        // videoPlaySpriteImageURL: '/assets/sprites/videoPlayButtonBlack.svg',
        // videoPauseSpriteImageURL: '/assets/sprites/videoPauseButtonBlack.svg',
        // videoButtonScale: {x: .2, y: .2, z: .2},
        // videoButtonPos:{x:9.17728, y:0.606917,z:11.6652},
        videoTextureEncoding: THREE.sRGBEncoding,
        // videoButtonPos:{x:-8.31443,y:-1.5 ,z:-29.7395 }
    },
    {
        paintingId: 'W03V01',
        videoId: 'W03V01',
        standaloneVideoElementId: 'W03V01',
        videoURL: 'W03V01.mp4',
        displayType: ANNOTATION_VIDEO_DISPLAY.VIDEO_STANDALONE | ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
        headerText: ``,
        bodyText: null,
        displayMesh: 'Y',
        displayHeight: 90,
        videoAutoPlay: 'N',
        // videoPlaySpriteImageURL: '/assets/sprites/videoPlayButtonBlack.svg',
        // videoPauseSpriteImageURL: '/assets/sprites/videoPauseButtonBlack.svg',
        // videoButtonScale: {x: .2, y: .2, z: .2},
        // videoButtonPos:{x:9.17728, y:0.606917,z:11.6652},
        videoTextureEncoding: THREE.sRGBEncoding,
        // videoButtonPos:{x:-8.31443,y:-1.5 ,z:-29.7395 }
    },
    /* Videos end */

    // Wall 1
    {
        paintingId: 'W01T01',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Remote Possibilities</h5>`,
        bodyText: `Phiona worked with a community group at Hazelwood Neighbourhood Centre in Corby. During the project the group creatively explored their local environment discovering how they link to people, places and history by using a variety of art journaling techniques such as mono printing, illuminated letters and collage.`,
    },
    // Wall 2
    {
        paintingId: 'W02T01',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>You’re in My Space</h5>`,
        bodyText: `Linzi worked with a local community group at Stephenson Way Community Centre in Corby, to explore a variety of art techniques over a period of six months.<br>Linzi introduced many new ideas including printmaking, felting, and drawing. In each of the experimental pieces, individuals were inspired by different aspects of themselves and their relationship to their environment.<br>Sometimes the work was abstract in appearance and at other times more literal.<br>An additional part of the project was a one day walk with artist Jo Dacombe, during which the group documented the local environment through words and images, giving individuals other inspiration for their practical pieces.<br>Everybody who took part created a final mixed media textile work that brings together all the skills they learnt.<br>
Alongside the creativity in each workshop lots of other meaningful conversation also happened.  “I've never done anything like this before, it's so exciting!”<br>“Being part of an art group has helped me find meaning in my community”<br>“I've enjoyed working alongside others and meeting new people in my community”`,
    },
    // Wall 3
    // Survey
    {
        paintingId: 'W04S01',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        displayMesh: 'N',
        headerText: `<h5>Have Your Say</h5>`,
        bodyText: `Thank you for visiting the gallery. We would really appreciate your feedback on the Connecting Corby project exhibited here. Your feedback helps us to keep extraordinary work for you and our communities free to everyone.`,
        contactUrlLabel: 'SURVEY',
        ContactURL: 'https://www.surveymonkey.co.uk/r/CHKQ5TT',
        spriteImageURL:process.env.PUBLIC_URL+'/assets/sprites/Feedbackicon.svg',
        annotationScale: {x:.3,y:.3,z:1},
    },
    {
        paintingId: 'W03T01',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Connections and Intersections</h5>`,
        bodyText: `We live in a divided world of rich/poor, homes/homeless, young/old, tired/energetic, inspired/inspiring and so on, we often find ourselves at different points on the road of life wondering, contemplating, pausing for a moment to take stock. I hoped this project would be a way to lessen division and bring diverse people together to make something beautiful, meaningful and unusual. I hope you will agree that my group rose to the challenge beautifully.<br>Through the course of the project we painted small wooden buildings and talked about what community and connection meant to us. We up-cycled vintage crockery, the kind often found in old community centres, by drawing and painting mythical creatures, treasured places in the area, flora and fauna, ponds and fiery furnaces. When we were working on the small batik hangings I asked the group to think about friendships and the things that were important to them whilst enjoying drawing with hot wax, almost a metaphor for the pouring of molten steel. There had been a request to work with clay, so we experimented with air drying clay which was cut with cookie cutters and painted to become the biscuits in our High Tea inspired elements within the final installation. We generated many small things because it is the accumulation of small things that can effect change over time; it is the small act of kindness, friendship, laughter and care that binds us together as a community in a very special part of Corby.<br>The copper framework began its life as a support for a floating perspex sculpture created in Beanfield Studios by Carole Miles and Jo Dacombe, which was displayed for one night only in the crypt at York Minster. My dear departed Dad; Michael Miles fabricated the copper, making an elegant portable structure that has been used to create a variety of different installations since then. One of the last things he did for me was to arrange to have the wood for the tiny houses cut to shape at Desborough Men’s Shed Project.`,
    },

    {
        paintingId: 'W03P01',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W03P01.jpg`,
        headerText: `<h5>Home and Away High Tea 1</h5>`,
        bodyText: `Metal tea trolley, Gardens in teacups, Small buildings`,
    },
    {
        paintingId: 'W03P02',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W03P02.jpg`,
        headerText: `<h5>Green Tea Pavilions</h5>`,
        bodyText: `Two wooden pavilions containing gardens in teacups by Susan Shier and Ann Leonard. Houses painted by Ann Leonard, Phiona Richards, Jayne Incles, Elaine Bruce, Jean Addison, Susan Shier and Carole Miles`,
    },
    {
        paintingId: 'W03P03',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W03P03.jpg`,
        headerText: `<h5>Home and Away High Tea 2</h5>`,
        bodyText: `Top view vintage wooden Savoy trolley<br>Sharing time together over a cup of tea or coffee is a gateway to friendships and greater understanding. Duos by Maureen Walvin, Elaine Bruce and Ann Leonard. Surrounded by clay ‘biscuits’ of trees and leaves.`,
    },
    {
        paintingId: 'W03P04',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W03P04.jpg`,
        headerText: `<h5>Tray of Memories</h5>`,
        bodyText: `Envelopes lay like sandwiches containing recorded observations and links showing how and where individuals connected over time, showing how they met or moved through the Kingswood area and other events that were triggered by those meetings.`,
    },
    {
        paintingId: 'W03P05',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W03P05.jpg`,
        headerText: `<h5>Drawer of Desserts</h5>`,
        bodyText: `Dessert fruit bowls in Beryl and Iris ware decorated with woodland patterns inspired by walks in Kingswood by Sara Stewart, Nina Freer, Susan Shier surrounded by photographs of summer flowers drawn by Jennifer Anne Gilkes.`,
    },

    {
        paintingId: 'W03P06',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W03P06.jpg`,
        headerText: `<h5>Old Village Cuppa</h5><h6>by Debbie Johnson</h6>`,
        bodyText: `This is a drawing over and around a vintage Beryl cup and saucer that takes the viewer on a walk through the Old Village in Corby where Debbie’s parents live and contains many powerful memories for her.`,
    },
    {
        paintingId: 'W03P07',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W03P07.jpg`,
        headerText: `<h5>Drawer of Coffee and Cake</h5>`,
        bodyText: `Hand painted vintage Beryl coffee pot and cake stand surrounded by hand painted clay ‘biscuits’. All items by Ann Leonard`,
    },
    {
        paintingId: 'W03P08',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W03P08.jpg`,
        headerText: `<h5>Connections and Intersections</h5>`,
        bodyText: `Whole installation – containing all the elements made during the course of the project and set out to represent the many journeys both the group and myself have made in, out, to, from, around and about Kingswood Neighbourhood Centre. It is a kind of three dimensional memory map that contains layers of time, shared experiences and the many other journeys that brought the group together.<br><b>Contributors</b><br>Susan Shier<br>Elaine Bruce<br>Ann Leonard<br>Sara Stewart<br>Ann Craske<br>Jennifer Anne Gilkes<br>Nina Freer<br>Maureen Walvin<br>Jean Addison<br>Debbie Johnson<br>Jayne Incles<br>Janice Crane Davies<br>Phiona Richards<br>Noel France<br>Carole Miles<br>Michael Miles`,
    },
    // Wall 4
    {
        paintingId: 'W04P03',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W04P03.jpg`,
        headerText: `<h5>Caroline Miles</h5>`,
        bodyText: `In her current practice Carole Miles uses a range of media, including digital imagery, photography and temporary site-specific interventions, which also incorporate found objects and traditional making skills. Carole enjoys the dynamism collaboration can bring to spaces, places and projects. She works with print, textiles, murals, up-cycling, mosaics, arts based public engagement and creative walking/wellbeing projects. She is passionately committed to working within the community and has a long track record of delivering projects, commissions and public artworks made in this context. Carole has worked across Corby in schools and community settings and as a collaborative artist since 1989 and some of her happiest times were spent in a shared studio space in the annex at Beanfield Primary School.<br>Carole Miles and Phiona Richards collaborate as The Eloquent Fold and are Associate Artists for Made With Many. Carole is lead artist and project coordinator for Back To Books, which delivers arts, walking and well being projects with disadvantaged people of all ages. Back To Books began its life in the old Corby Community Arts building in what used to be Canada Square on the Kingswood estate.`,
        ContactURL: `http://carole-miles.blogspot.com/?m=0`,


    },
    {
        paintingId: 'W04P02',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W04P02.jpg`,
        headerText: `<h5>Linzi Bright</h5>`,
        bodyText: `Linzi is a Northamptonshire based artist working with a variety of 2D and 3D materials and techniques, and specialises in printmaking and mixed media work. Linzi has worked on many arts projects from one day events to six month community projects, and uses creativity to enable individuals to share ideas and bring communities together.`,
        facebookUrl: 'http://www.facebook.com/ArtistDesignerEducator',


    },
    {
        paintingId: 'W04P01',
        videoId: null,
        videoURL: null,
        imageURL: `/paintings/W04P01.jpg`,
        headerText: `<h5>Phiona Richards</h5>`,
        bodyText: `Phiona Richards is a Socially Engaged artist based in Corby, Northamptonshire and an Associate Artist for Made With Many. Her award winning work has been exhibited locally, nationally and internationally and she has also made an appearance on the Channel Four series, Kirstie’s Handmade Britain.<br>Her work is a combination of books and stitch, both of which were important to her as a child and have informed many creative adventures. As a Book Sculptor, she creates jewellery and non-functional pieces which form the basis of her book art.`,
        ContactURL: 'http://www.rarenotions.co.uk',

    },
    {
        paintingId: 'W04T01',
        videoId: null,
        videoURL: null,
        isMediaUsed: 'N',
        headerText: `<h5>Connecting Corby</h5>`,
        bodyText: `In October 2019 three new community art groups popped up in Corby, each group welcomed people of all ages and backgrounds to meet together and create. From the very beginning sessions were an opportunity to meet neighbours and reconnect with the local community. Every week those taking part had the opportunity to try new techniques; printing, felting, batik amongst dozens more, all guided by a local artist.<br>Over the course of six months, each group had built up a collection of work that we planned to display in April 2020. Circumstances meant that both of these events, and the final sessions for each group were cancelled. Several months later, we are very pleased to present some of the extraordinary work that was created throughout the project, here, online for everyone to enjoy.<br>Connecting Corby was created by groups in Stephenson Way Community Centre, Hazelwood Neighbourhood Centre and Kingswood Neighbourhood Centre.<br>Sessions were led by Linzi Bright, Carole Miles and Phiona Richards.<br>Connecting Corby is a project that aims to create connections within communities and combat loneliness in the town, the two year project is funded by The National Lottery Community Fund and HM Government.<br><b>Made With Many</b><br>Made With Many is a programme of new arts and cultural activities focussing on working with local communities in Corby and Wellingborough to ensure that the arts are at the heart of positive change. To find out more visit the link below.`,
        ContactURL: 'http://www.madewithmany.org',
    },
];

export {AnnotationsDB};
